import http from "@/plugins/http";
// 获取列表
export function getUserList(data) {
  return http({
    url: `/webAccount/list`,
      params:data,
      method: 'GET',
  });
}

// 新增
export function createUser(data) {
  return http({
    url: `/webAccount/add`,
    data: data,
    method: "POST"
  });
}

// 详情
export function showUser(data) {
    return http({
        url: `/webAccount/info`,
        params:data,
        method: 'GET',
    })
}

// 编辑
export function editUser(data) {
    return http({
        url: `/webAccount/update`,
        data: data,
        method: "POST"
    })
}

// 删除
export function deleteUser(data) {
  return http({
      url: `/webAccount/delete`,
      params:data,
      method: 'GET',
  });
}

// 编辑
export function changeStatus(data) {
    console.log(data);
    return http({
        url: `/webAccount/changeStatus`,
        data:data,
        method: 'POST',
    })
}

// 重置密码 TODO
export function updatePwd(data) {
  console.log(data);
  return http({
    url: `/webAccount/changePwd`,
      params:data,
      method: 'GET',
  })
}
// 修改密码
export function changePassword(data) {
  console.log(data);
  return http({
    url: `/webAccount/changePwd`,
      params:data,
      method: 'GET',
  })
}

// 修改密码
export function resetPassword(data) {
    console.log(data);
    return http({
        url: `/webAccount/resetPwd`,
        params:data,
        method: 'GET',
    })
}
// 发送短信验证码密码
export function sendMessage(data) {
  console.log(data);
  return http({
    url: `/webAccount/getCrc`,
      params:data,
      method: 'GET',
  })
}